import React from "react";

const Tooltip = ({ feature }) => {
  const { id } = feature.properties;

  return (
    <div id={`tooltip-${id}`} className="font-serif">
      <p><strong>Name:</strong> {feature.properties.name}</p>
      <p><strong>Year:</strong> {feature.properties.date_part}</p>
      <p><strong>Location:</strong> {feature.properties.location_search_term_raw}</p>
      <p><strong>Context:</strong> {feature.properties.window_text.replace('[', '').replace(']', '').replace(/'/g, '').replace(/,/g, '')}</p>
    </div>
  );
};

export default Tooltip;